export default () => ({
  infos: [],
});
